import { FormControlLabel, FormControlLabelText } from "@gluestack-ui/themed";
import { IInputLabel } from "./types";

export const InputLabel = ({ label, light }: IInputLabel) => {
  if (!label) return null;

  return (
    <FormControlLabel mb="$1">
      <FormControlLabelText
        light={light}
        $web-fontFamily="Roboto"
        fontFamily="Roboto_500Medium"
        fontWeight={500}
        size="sm"
      >
        {label}
      </FormControlLabelText>
    </FormControlLabel>
  );
};
